import React, { useEffect } from 'react';
import { Form } from 'antd';
import CustomerPhoneNumberInput from '../../../inputs/customerPhoneInput/CustomerPhoneNumberInput';
import CustomerTextInput from '../../../inputs/customerTextInput/CustomerTextInput';
import useTranslation from '../../../../hooks/translation/useTranslation';
import CustomerCheckInput from '../../../inputs/customerCheckInput/CustomerCheckInput';
import { useAuth } from '../../../../contexts/userContext/userContext';

function PersonInfo({
  options, personType = '', form, title, withIdNumber = false,
}) {
  const { user } = useAuth();
  const { trans } = useTranslation();
  const isBooker = Form.useWatch([personType, 'isBooker'], form);

  useEffect(() => {
    if (isBooker) {
      form.setFieldsValue({
        [personType]: {
          first_name: form.getFieldValue(['booker', 'first_name']),
          last_name: form.getFieldValue(['booker', 'last_name']),
          phone_number: form.getFieldValue(['booker', 'phone_number']),
          country_phone_code: form.getFieldValue(['booker', 'country_phone_code']),
          id_number: form.getFieldValue(['booker', 'id_number']),
        },
      });
    } else {
      form.setFieldsValue({
        [personType]: {
          first_name: '',
          last_name: '',
          phone_number: '',
          country_phone_code: '',
          id_number: '',
        },
      });
    }
  }, [isBooker]);

  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-col lg:flex-row lg:items-center lg:gap-5">
        <h3 className="font-big-bold ">
          {title}
        </h3>
        {user?.type === 'physical' && (
        <CustomerCheckInput
          name={[personType, 'isBooker']}
          label="მგზავრი იყოს განმცხადებელი"
        />
        )}
      </div>
      <div className="flex flex-col">
        {withIdNumber
          ? (
            <CustomerTextInput
              name={[personType, 'id_number']}
              label={trans('id_number')}
              disabled={isBooker}
              rules={[{
                required: true,
                message: trans('input_necessary'),
              }]}
            />
          )
          : (
            <CustomerPhoneNumberInput
              name={[personType, 'phone_number']}
              label={trans('phone_number')}
              selectName={[personType, 'country_phone_code']}
              options={options.phoneCodes}
              disabled={isBooker}
              codeSelectDisabled={isBooker}
              rules={[{
                required: true,
                message: trans('input_necessary'),
              }]}
            />
          )}
        <CustomerTextInput
          name={[personType, 'first_name']}
          label={trans('first_name')}
          disabled={isBooker}
          rules={[{
            required: true,
            message: trans('input_necessary'),
          }]}
        />
        <CustomerTextInput
          name={[personType, 'last_name']}
          label={trans('last_name')}
          disabled={isBooker}
          rules={[{
            required: true,
            message: trans('input_necessary'),
          }]}
        />
      </div>
    </div>
  );
}

export default PersonInfo;
